import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { CarePlanCase } from '../../care-plan.model';
import { CarePlanStore } from '../../care-plan.store';
import { CaseStatusBadgeComponent } from '../case-status-badge/case-status-badge.component';
import { CaseDetailComponent } from '../case-detail/case-detail.component';

/**
 * One case row: chevron + objective title, expanding in place into
 * `bn-case-detail` (D11). The status badge only rides along when the list is
 * not grouped by status — otherwise the group banner already says it.
 */
@Component({
  selector: 'bn-case-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, CaseStatusBadgeComponent, CaseDetailComponent],
  templateUrl: './case-card.component.html',
  styleUrl: './case-card.component.scss',
})
export class CaseCardComponent {
  protected readonly store = inject(CarePlanStore);

  readonly case = input.required<CarePlanCase>();

  protected readonly expanded = computed(
    () => this.store.expandedCaseId() === this.case().id,
  );
  protected readonly showStatusBadge = computed(
    () => this.store.groupBy() !== 'status',
  );
  protected readonly panelId = computed(
    () => `bn-case-panel-${this.case().id}`,
  );

  toggle(): void {
    this.store.toggleExpandedCase(this.case().id);
  }

  collapse(): void {
    this.store.setExpandedCase(null);
  }
}
